document.addEventListener("DOMContentLoaded", function () {
  //accordionScroll()
});

function accordionScroll() {
  const allScrollComponents = document.querySelectorAll(".ps-accordian-folder-section");
  allScrollComponents.forEach(component => {
    let listItems = component.querySelectorAll(".accordion-trigger");
    let totalitemscount = listItems.length;
    listItems.forEach((item, index) => {
      totalitemscount--;
      item.setAttribute("role", "button");
      item.setAttribute("aria-expanded", "false");
      item.setAttribute("aria-controls", `accordion${index + 1}`);
      item.setAttribute("aria-label", `Expand section ${index + 1}`);

      // Function to handle scrolling
      function handleScroll(event) {
        event.preventDefault(); // Prevents form from submitting
        let targetSection = item.closest(".stack_section");

        if (targetSection) {
          const targetPosition = targetSection.getBoundingClientRect().top + window.scrollY;
          let distanceToScroll = window.innerHeight - ((listItems.length - index)*60);
           distanceToScroll = item.getBoundingClientRect().top - ((listItems.length - index)*60);
          window.scrollBy({
            top: distanceToScroll, // Scroll up by one full viewport height
            behavior: "smooth", // Smooth scrolling effect
          });
          const isExpanded = item.getAttribute("aria-expanded") === "true";
          item.setAttribute("aria-expanded", !isExpanded);
          item.setAttribute("aria-label", !isExpanded ? `Collapse section ${index + 1}` : `Expand section ${index + 1}`);
        }
      }

      // Click event
      item.addEventListener("click", handleScroll);
      item.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          handleScroll(event);
        }
      });
    });
  });
};


document.querySelectorAll('.accordion-trigger').forEach(trigger => {
  trigger.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent default anchor behavior
  });
});
